import React, { useState, useEffect } from "react";
import Row from "@amzn/meridian/row";

const Video = ({ widthRatio, src }) => {
  const [videoWidth, setVideoWidth] = useState(window.innerWidth * widthRatio);

  useEffect(() => {
    const handleResize = () => {
      setVideoWidth(window.innerWidth * widthRatio);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener when the component is unmounted
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const aspectRatio = 16/9;

  return (
    <Row alignmentHorizontal="center">
      <iframe
        width={videoWidth}
        height={videoWidth / aspectRatio}
        src={src}
        title="Amazon Approved Headphones Program"
        style={{ border: 0 }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      ></iframe>
    </Row>
  );
};

export default Video;